import React, { useState } from 'react'
import Cookies from 'universal-cookie'
import isProd from '../../utils/constants/isProd'

const ModalAnalogs = () => {
    const sessid = isProd ? window.BX.bitrix_sessid() : 'random_hash'

    const cookies = new Cookies()
    const analogsModalCookieName = 'analogs_modal'
    const analogsModalCookiePath = '/'

    const isShowModal = () => {
        const analogsModalCookie = cookies.get(analogsModalCookieName)

        if (analogsModalCookie) {
            if (analogsModalCookie.hide_for_sessid === sessid) {
                return false
            }
        }

        return true
    }

    const [isModalActive, setIsModalActive] = useState(isShowModal)

    const deactivateModal = () => {
        setIsModalActive(false)

        cookies.set(
            analogsModalCookieName,
            { hide_for_sessid: sessid },
            {
                path: analogsModalCookiePath,
                domain: window.location.hostname,
                maxAge: 60 * 60 * 24 * 7
            }
        )
    }

    return (
        <div className={isModalActive ? 'modal-analogs active' : 'modal-analogs'}>
            <div className="modal__content">
                <div className="modal-analogs-info__title">Больше аналогов тут</div>
                <div className="modal-analogs-info__text">
                    Кликайте на артикул, чтобы увидеть список аналогов к этому артикулу
                </div>
                <span className="modal-analogs-info__button" onClick={() => deactivateModal()}>
                    Понятно
                </span>
            </div>
        </div>
    )
}

export default ModalAnalogs
